// extracted by mini-css-extract-plugin
export default {"fullHeight":"SecondScreenNote_fullHeight__QGc8m","slideMenu":"SecondScreenNote_slideMenu__WVDr-"};